import { render, staticRenderFns } from "./CreditsIndicator.vue?vue&type=template&id=c05ae4da&scoped=true"
import script from "./CreditsIndicator.vue?vue&type=script&lang=js"
export * from "./CreditsIndicator.vue?vue&type=script&lang=js"
import style0 from "./CreditsIndicator.vue?vue&type=style&index=0&id=c05ae4da&prod&scoped=true&lang=scss"
import style1 from "./CreditsIndicator.vue?vue&type=style&index=1&id=c05ae4da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05ae4da",
  null
  
)

export default component.exports